const base = '/organization/phishing_simulator';

export function phishingNavigation(items, t) {
  const localized = (items || []).map(item => ({ ...item,
    label: item.to === `${base}/phishing_campaign` ? t('phishing_campaign.title')
      : item.to === `${base}/templates` ? t('template_gallery.menu')
        : item.to === `${base}/usersandgroups` ? t('users_and_groups.title')
          : item.to === `${base}/smtpconfig` ? t('smtp_config.title')
            : item.to === `${base}/delivery-settings` ? t('delivery_settings.title') : item.label,
    ...(item.content ? { content: phishingNavigation(item.content, t) } : {})
  }));
  // The local review still reads the production menu. Insert the new item
  // beside Sending profiles until the server menu is published as well.
  const index = localized.findIndex(item => item.to === `${base}/smtpconfig`);
  if (index >= 0 && !localized.some(item => item.to === `${base}/delivery-settings`)) {
    localized.splice(index + 1, 0, { to: `${base}/delivery-settings`, icon: 'pe-7s-shield', label: t('delivery_settings.title') });
  }
  return localized;
}
